import showdown from "showdown";

export const markdownConverter = new showdown.Converter();
